/**
 * Choyce Creative Organization Configuration
 *
 * This application is single-tenant and hard-coded to use only the Choyce Creative organization.
 */

export const CHOYCE_CREATIVE_ORG_ID = 'ujvC5aNPbLkvIBka0kb7'
export const CHOYCE_CREATIVE_ORG_NAME = 'Choyce Creative'

/**
 * Default branding colors (fallback if organization data isn't loaded yet)
 * These should match the colors configured in the Choyce Creative organization settings
 */
export const DEFAULT_BRAND_COLORS = {
  primary: '#6366f1', // Choyce Future indigo
  secondary: '#ec4899', // Choyce Future pink
}

/**
 * Choyce Creative branding assets
 * Hard-coded for single-tenant deployment to display on login page before authentication
 */
export const CHOYCE_CREATIVE_ORG = {
  id: CHOYCE_CREATIVE_ORG_ID,
  name: CHOYCE_CREATIVE_ORG_NAME,
  logoUrl: 'https://firebasestorage.googleapis.com/v0/b/prepro-e0f8f.firebasestorage.app/o/organizations%2FujvC5aNPbLkvIBka0kb7%2Fbranding%2Flogo.png?alt=media&token=5a00999d-a147-42d2-86ee-f87ed2108d34',
  darkModeLogoUrl: 'https://firebasestorage.googleapis.com/v0/b/prepro-e0f8f.firebasestorage.app/o/organizations%2FujvC5aNPbLkvIBka0kb7%2Fbranding%2Flogo_darkmode.png?alt=media&token=73f4db3e-dce3-439e-8cb2-6f915e334829',
  faviconUrl: '/logos/prepro-favicon.svg',
  // Brand colors - will be overwritten with actual values from database after auth
  colors: DEFAULT_BRAND_COLORS,
}

/**
 * Check if multi-tenant features should be enabled
 * Currently disabled for single-tenant Choyce Creative deployment
 */
export const IS_MULTI_TENANT = false
